import { useMemo } from 'react';
import { useSports } from '../queries';

const queryParams = { limit: 50 };

export const useMarketExclusionSports = () => {
  const { data } = useSports(queryParams);
  const sportOptions = useMemo(() => (data?.items || []).map(({ id, name }) => ({ id, name })), [data?.items]);
  const sportsById = useMemo(() => new Map(sportOptions.map(({ id, name }) => [id, name])), [sportOptions]);

  return { sportOptions, sportsById };
};
